/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number_times_longer: NonNullable<unknown> }} Onboarding_Paywall_TitleInputs */

const en_onboarding_paywall_title = /** @type {(inputs: Onboarding_Paywall_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Plus users focus up to ${i?.number_times_longer}`)
};

const ar_onboarding_paywall_title = /** @type {(inputs: Onboarding_Paywall_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`يستطيع مستخدمو بلس التركيز حتى ${i?.number_times_longer}`)
};

const de_onboarding_paywall_title = /** @type {(inputs: Onboarding_Paywall_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Plus-Nutzer fokussieren bis zu ${i?.number_times_longer}`)
};

const es_onboarding_paywall_title = /** @type {(inputs: Onboarding_Paywall_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Los usuarios Plus se concentran hasta ${i?.number_times_longer}`)
};

const fr_onboarding_paywall_title = /** @type {(inputs: Onboarding_Paywall_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Les utilisateurs Plus se concentrent jusqu'à ${i?.number_times_longer}`)
};

const it_onboarding_paywall_title = /** @type {(inputs: Onboarding_Paywall_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gli Utenti Plus si concentrano fino a ${i?.number_times_longer}`)
};

const ja_onboarding_paywall_title = /** @type {(inputs: Onboarding_Paywall_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Plusユーザーは最大${i?.number_times_longer}集中可能`)
};

const ko_onboarding_paywall_title = /** @type {(inputs: Onboarding_Paywall_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Plus 사용자는 집중 시간이 최대 ${i?.number_times_longer}`)
};

const pt_br_onboarding_paywall_title = /** @type {(inputs: Onboarding_Paywall_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Usuários Plus mantêm até ${i?.number_times_longer} de foco`)
};

const ru_onboarding_paywall_title = /** @type {(inputs: Onboarding_Paywall_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Пользователи Plus фокусируются в ${i?.number_times_longer}`)
};

const th_onboarding_paywall_title = /** @type {(inputs: Onboarding_Paywall_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ผู้ใช้ Plus โฟกัสได้นานขึ้นถึง ${i?.number_times_longer}`)
};

const tr_onboarding_paywall_title = /** @type {(inputs: Onboarding_Paywall_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Plus kullanıcılar ${i?.number_times_longer} odaklanır`)
};

const zh_cn_onboarding_paywall_title = /** @type {(inputs: Onboarding_Paywall_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Plus 会员平均专注时间多 ${i?.number_times_longer}`)
};

const zh_tw_onboarding_paywall_title = /** @type {(inputs: Onboarding_Paywall_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Plus 用戶平均專注時間多 ${i?.number_times_longer}`)
};

/**
* | output |
* | --- |
* | "Plus users focus up to {number_times_longer}" |
*
* @param {Onboarding_Paywall_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const onboarding_paywall_title = /** @type {((inputs: Onboarding_Paywall_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Paywall_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_paywall_title(inputs)
	if (locale === "ar") return ar_onboarding_paywall_title(inputs)
	if (locale === "de") return de_onboarding_paywall_title(inputs)
	if (locale === "es") return es_onboarding_paywall_title(inputs)
	if (locale === "fr") return fr_onboarding_paywall_title(inputs)
	if (locale === "it") return it_onboarding_paywall_title(inputs)
	if (locale === "ja") return ja_onboarding_paywall_title(inputs)
	if (locale === "ko") return ko_onboarding_paywall_title(inputs)
	if (locale === "pt_br") return pt_br_onboarding_paywall_title(inputs)
	if (locale === "ru") return ru_onboarding_paywall_title(inputs)
	if (locale === "th") return th_onboarding_paywall_title(inputs)
	if (locale === "tr") return tr_onboarding_paywall_title(inputs)
	if (locale === "zh_cn") return zh_cn_onboarding_paywall_title(inputs)
	return zh_tw_onboarding_paywall_title(inputs)
});